export const pricingData = [
  // WEDDING
  {
    id: "wedding-essential",
    category: "wedding",
    icon: "💍",
    title: "Essential Wedding",
    price: 1950,
    currency: "CHF",
    features: [
      "8 hours of coverage",
      "Ceremony + Apero + couple session",
      "Minimum 250 professionally edited images",
      "Private online gallery (for you + guests)",
      "Sneak peek within 48 hours",
      "Delivery within 3–4 weeks",
    ],
  },
  {
    id: "wedding-complete",
    category: "wedding",
    icon: "💍",
    title: "Complete Collection\n(Most Popular)",
    price: 2900,
    currency: "CHF",
    highlight: true,
    features: [
      "Up to 12 hours coverage",
      "Preparations + ceremony",
      "Pre-wedding OR post-wedding session",
      "400+ professionally edited images",
      "Private online gallery",
      "Sneak peek within 48 hours",
      "Delivery within 3 weeks",
    ],
  },
  {
    id: "wedding-premium",
    category: "wedding",
    icon: "💍",
    title: "Signature Collection",
    price: 4800,
    currency: "CHF",
    highlight: true,
    features: [
      "Full wedding day coverage (up to 15 hours)",
      "Pre-wedding session included",
      "Second photographer included",
      "600+ professionally edited images",
      "Priority delivery (2 weeks)",
      "Private online gallery",
      "Sneak peek within 24–48 hours",
    ],
  },

  // FAMILY
  {
    id: "family-essential",
    category: "family-session",
    icon: "👨‍👩‍👧‍👦",
    title: "Essential Family",
    price: 490,
    currency: "CHF",
    description: "Family session",
    features: [
      "Up to 60 minutes session",
      "Outdoor location of your choice",
      "25 professionally edited images",
      "Private online gallery",
      "Delivery within 2–3 weeks",
    ],
  },
  {
    id: "family-complete",
    category: "family-session",
    icon: "👨‍👩‍👧‍👦",
    title: "Complete Family\n(Most Popular)",
    price: 750,
    currency: "CHF",
    highlight: true,
    description: "Family session",
    features: [
      "Up to 90 minutes session",
      "1–2 nearby locations",
      "50 professionally edited images",
      "Private online gallery",
      "Sneak peek within 72 hours",
      "Delivery within 2 weeks",
    ],
  },
  {
    id: "family-signature",
    category: "family-session",
    icon: "👨‍👩‍👧‍👦",
    title: "Signature Family",
    price: 1200,
    currency: "CHF",
    description: "Family session",
    features: [
      "Up to 2 hours session",
      "Multiple locations",
      "80+ professionally edited images",
      "Priority delivery (1 week)",
      "Private online gallery",
    ],
  },

  // COUPLE
  {
    id: "couple-essential",
    category: "couple-session",
    icon: "💑",
    title: "Essential Couple",
    price: 650,
    currency: "CHF",
    description: "Intimate / couple session",
    features: [
      "Up to 75 minutes",
      "1 outdoor location",
      "30 professionally edited images",
      "Private online gallery",
      "Delivery within 2–3 weeks",
    ],
  },
  {
    id: "couple-complete",
    category: "couple-session",
    icon: "💑",
    title: "Complete Couple\n(Most Popular)",
    price: 980,
    currency: "CHF",
    highlight: true,
    description: "Intimate / couple session",
    features: [
      "Up to 90–120 minutes",
      "1–2 locations",
      "50 professionally edited images",
      "Styling guidance",
      "Sneak peek within 72 hours",
      "Private online gallery",
      "Delivery within 2 weeks",
    ],
  },
  {
    id: "couple-signature",
    category: "couple-session",
    icon: "💑",
    title: "Signature Couple",
    price: 1450,
    currency: "CHF",
    description: "Intimate / couple session",
    features: [
      "Up to 2 hours",
      "Multiple curated locations",
      "80+ professionally edited images",
      "Outfit change",
      "Priority delivery (1 week)",
    ],
  },

  // BRAND
  {
    id: "brand-basic",
    category: "brand",
    icon: "📸",
    title: "Brand Basic",
    price: 650,
    currency: "CHF",
    description: "Brand content",
    features: [
      "Up to 4 hours of shooting",
      "25 professionally edited high-resolution images",
      "Social media usage (organic, non-paid)",
      "1 pre-shoot planning call",
      "Delivery within 7 days",
    ],
  },
  {
    id: "brand-pro",
    category: "brand",
    icon: "📸",
    title: "Brand Pro",
    price: 1200,
    currency: "CHF",
    description: "Professional brand content",
    features: [
      "6 hours",
      "40 high-resolution edited photos",
      "Commercial use included",
      "1 social media Reel",
      "Delivery within 7 days",
    ],
  },

  // SOCIAL MEDIA CONTENT
  {
    id: "social-starter",
    category: "social-media-content",
    icon: "📸",
    title: "Starter Package",
    price: 550,
    currency: "CHF",
    description: "Ideal for small restaurants and businesses that want to improve their social media presence.",
    features: [
      "Up to 4 hours on location",
      "20 professionally edited photos",
      "Social media usage rights",
      "Delivery within 7 days",
    ],
    note: "Perfect for: menu updates, seasonal dishes, Instagram refresh.",
  },
  {
    id: "social-professional",
    category: "social-media-content",
    icon: "📸",
    title: "Professional Package",
    price: 1100,
    currency: "CHF",
    description: "For established restaurants and growing brands that need higher-level content.",
    features: [
      "Up to 8 hours of production",
      "40 high-resolution edited photos",
      "1–2 vertical reels",
      "Commercial usage rights included",
      "Delivery within 7 days",
    ],
    note: "Perfect for: brand campaigns, launches, website updates, advertising content.",
  },

  // MONTHLY CONTENT
  {
    id: "content-partner-essential",
    category: "monthly-content",
    icon: "📸",
    title: "Essential Partner",
    price: 1500,
    currency: "CHF",
    description: "Ongoing visual production and creative support.",
    features: [
      "1 production day (6–8 hours)",
      "40–50 edited photos",
      "2 vertical reels",
      "Monthly content planning",
      "Priority delivery",
      "Social & digital usage rights",
    ],
  },
  {
    id: "content-partner-growth",
    category: "monthly-content",
    icon: "📸",
    title: "Growth Partner",
    price: 2200,
    currency: "CHF",
    highlight: true,
    description: "Ongoing visual production and creative support.",
    features: [
      "Up to 16 hours production (split sessions)",
      "80+ edited photos",
      "4 optimized reels",
      "Creative direction",
      "Monthly strategy session",
      "Extended commercial usage rights",
      "Priority booking",
    ],
  },

  // UNIVERSAL CEREMONY PACKAGE
  {
    id: "ceremony-package",
    categories: "wedding",
    icon: "📸",
    title: "Ceremony Package",
    price: 1000,
    currency: "CHF",
    description: "Available for selected session types",
    features: [
      "4–6 hours",
      "Ceremony + Couple Session",
      "Digital Gallery",
      "Delivered within 5 days",
    ],
  },
];
